// extracted by mini-css-extract-plugin
export default {"container":"YE-z","disabled":"ZE-z","bgBlack":"_E-z","content":"aF-z","countdown":"bF-z","topCaption":"cF-z","topHeading":"dF-z","heading":"eF-z","copy":"fF-z"};